import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { IonButton, IonIcon, IonContent, IonSlides, IonSlide } from '@ionic/react';
import { chevronBackOutline, chevronForwardOutline } from 'ionicons/icons';
import { Map, GoogleApiWrapper, Marker } from '../googleMapsReact';
import { getConfig } from '../../appConfig.js';
import { withTranslation } from '../../lib/translate';
import { isDefined, emptyString } from '../../lib/utils';
import Pullup from '../pullup';
import { Title, NormalText, StrongText } from '../common';
import Loading from '../spinner';
import './index.css';
import { getRestaurants } from '../../store/actions';

const embedLocationInMapLayer = false;

export class MapContainer extends Component {
  constructor(props) {
    super(props);

    this.sliderRef = React.createRef();
    this.state = {
      stores: [],
      map: null,
      locationId: null,
      locationHolderNested: false,
      slideInit: false,
      initialLatCenter: getConfig().services.google_maps.defaultLat,
      initialLngCenter: getConfig().services.google_maps.defaultLng,
      initialZoom: 18,
    };
  }

  setStoresState = () => {
    let locations = [];
    this.props.restaurants.forEach((restaurant) => {
      if (
        restaurant &&
        restaurant.is_published &&
        restaurant.position &&
        restaurant.position !== null
      ) {
        const position = this.parseLocation(restaurant.position);
        locations.push({
          latitude: position.lat,
          longitude: position.lng,
          ...restaurant,
        });
      }
    });
    if (locations.length > 0) {
      const locationId = locations[0].id;
      this.setState({
        stores: locations,
        locationId,
        initialLatCenter: locations[0].latitude,
        initialLngCenter: locations[0].longitude,
      });
    }
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getRestaurants());
    this.setStoresState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.restaurants.length !== this.props.restaurants.length) {
      this.setStoresState();
    }
    if (
      this.props.restaurants &&
      this.props.restaurants.length > 0 &&
      prevProps.restaurants &&
      prevProps.restaurants.length > 0 &&
      prevProps.restaurants[0].distance &&
      this.props.restaurants[0].distance &&
      prevProps.restaurants[0].distance !== this.props.restaurants[0].distance
    ) {
      this.setStoresState();
    }
  }

  onMapReady = (mapProps, map) => {
    this.setState({ map });
  };

  displayMarkers = () => {
    return (this.state.stores || {}).map((store, index) => {
      return (
        <Marker
          key={index}
          id={store.id}
          position={{
            lat: store.latitude,
            lng: store.longitude,
          }}
          zIndex={store.id === this.state.locationId ? 10 : 0}
          onClick={this.onMarkerClick}
          name={store.name}
        />
      );
    });
  };

  onMarkerClick = (props, marker) => {
    const store = this.state.stores.find((s) => s.id === props.id);
    const slide = this.state.stores.indexOf(store) + 1;
    this.setState(
      {
        activeMarker: marker,
        locationId: props.id,
        slideInit: false,
      },
      () => this.changeSlide(null, slide),
    );
  };

  changeSlideArrow = (direction = 'next') => {
    if ((this.state.stores || []).length <= 1) {
      return;
    }
    this.setState({ slideChangedUsingArrows: true }, () => {
      if (direction === 'next') {
        this.sliderRef.current.slideNext();
      }
      if (direction === 'prev') {
        this.sliderRef.current.slidePrev();
      }
    });
  };

  changeSlide = (direction = 'next', slide = null) => {
    if ((this.state.stores || []).length <= 1) {
      return;
    }
    if (direction === 'next') {
      this.sliderRef.current.slideNext();
    }
    if (direction === 'prev') {
      this.sliderRef.current.slidePrev();
    }
    if (isDefined(slide)) {
      this.sliderRef.current.slideTo(slide);
    }
  };

  changeMarker = (direction) => {
    const { stores, locationId, /*map,*/ slideInit } = this.state;
    if (!slideInit) {
      this.setState({ slideInit: true });
      return;
    }
    let nextIndex;
    const current = stores.find((s) => s.id === locationId);
    const curentIndex = stores.indexOf(current);
    if (direction === 'next') {
      if (curentIndex === stores.length - 1) {
        nextIndex = 0;
      } else {
        nextIndex = curentIndex + 1;
      }
    } else {
      if (curentIndex === 0) {
        nextIndex = stores.length - 1;
      } else {
        nextIndex = curentIndex - 1;
      }
    }
    const store = stores[nextIndex];

    this.setState({ locationId: store.id }, () => {
      this.displayMarkers();
      this.zoomToTheMarker();
    });
  };

  parseLocation = (location = '') => {
    if (isDefined(location) && location !== '') {
      let position = location.split(',');
      return {
        lat: position[0],
        lng: position[1],
      };
    }

    return {};
  };

  zoomToTheMarker = () => {
    // use initial Lat and Lng for center map
    const { locationId, stores, map } = this.state;
    if (isDefined(locationId) && stores.length > 0) {
      this.setState({ slideChangedUsingArrows: false }, () => {
        const selectedRestaurant = stores.find((s) => s.id === locationId);
        if (
          isDefined(selectedRestaurant) &&
          isDefined(selectedRestaurant.latitude) &&
          isDefined(selectedRestaurant.longitude)
        ) {
          const lat = parseFloat(selectedRestaurant.latitude);
          const lng = parseFloat(selectedRestaurant.longitude);
          const initialZoom = 18;
          this.setState({ initialLatCenter: lat, initialLngCenter: lng, initialZoom }, () => {
            if (lat && lng) {
              map.panTo({ lat, lng });
              map.setZoom(initialZoom);
            }
          });
        }
      });
    }
  };

  nestLocationLayer = () => {
    if (document) {
      const mapTG = document.querySelector('.gm-style');
      if (mapTG) {
        const locationHolder = document.querySelector('.map-location-pullup');
        mapTG.appendChild(locationHolder);
      }
    }
  };

  mapBoundsChanged = () => {
    if (!this.state.locationHolderNested) {
      this.setState({
        locationHolderNested: true,
      });
      this.nestLocationLayer();
    }
  };

  render() {
    const { __ } = this.props;
    const { stores, locationId, initialLatCenter, initialLngCenter, initialZoom } = this.state;
    let selectedRestaurant = null;
    let slideIndex = null;
    if (isDefined(locationId) && stores.length > 0) {
      selectedRestaurant = stores.find((s) => s.id === locationId);
      slideIndex = stores.indexOf(selectedRestaurant);
    }

    let isMonToFriSame = true;
    let ot = null;
    let ct = null;
    if (selectedRestaurant) {
      (selectedRestaurant.json_opening_times || []).forEach((item) => {
        if (['w6', 'w0'].indexOf(item.day_code) !== -1) {
          return;
        }
        if (!ot) {
          ot = item.open_time;
        }
        if (!ct) {
          ct = item.close_time;
        }
        isMonToFriSame = ot === item.open_time && ct === item.close_time && isMonToFriSame;
      });
    }
    let height = '100%';
    let dynamicHeaderHeight = 50;
    if (
      document &&
      document.querySelector('.map-location-pullup') &&
      document.querySelector('.dynamic-header')
    ) {
      dynamicHeaderHeight = document.querySelector('.dynamic-header').clientHeight;
      height =
        document.querySelector('.map-location-pullup').offsetTop !== 0
          ? parseInt(document.querySelector('.map-location-pullup').offsetTop - dynamicHeaderHeight)
          : '100%';
    }
    return (
      <Loading additionalLoadingCondition={!isDefined(stores) || stores.length === 0}>
        <Map
          google={this.props.google}
          zoom={initialZoom}
          className="map"
          initialCenter={{ lat: initialLatCenter, lng: initialLngCenter }}
          streetViewControlOptions={{ position: 7 }}
          zoomControlOptions={{ position: 7 }}
          onBounds_changed={() => (embedLocationInMapLayer ? this.mapBoundsChanged : null)}
          onReady={this.onMapReady}
          style={{ height }}
        >
          {this.displayMarkers()}
        </Map>
        <Pullup
          className="map-location-pullup"
          top={35}
          offsetTop={170}
          offsetBottom={window.innerHeight / 2}
          isMap={true}
        >
          <div className="map-location-holder">
            <div className="map-location-content">
              <div className="map-location-nav" onClick={() => this.changeSlideArrow('prev')}>
                <IonButton size="small" fill="clear">
                  <IonIcon slot="icon-only" color="gray" icon={chevronBackOutline} />
                </IonButton>
              </div>
              <IonContent keyscrollEvents={true}>
                <IonSlides
                  className={(stores || []).length <= 1 ? 'swiper-no-swiping' : ''}
                  ref={this.sliderRef}
                  options={{ loop: true, initialSlide: slideIndex }}
                  onIonSlidePrevEnd={() => {
                    this.setState({ slideChangedUsingArrows: true });
                    this.changeMarker('prev');
                  }}
                  onIonSlideNextEnd={() => {
                    this.setState({ slideChangedUsingArrows: true });
                    this.changeMarker('next');
                  }}
                >
                  {stores.map((store, i) => {
                    return (
                      <IonSlide key={'slide-' + i}>
                        <div>
                          <Title className="secondary-title">{store.name}</Title>
                        </div>
                        {store.address ? (
                          <div>
                            <StrongText className="map-text roboto-slab">{__('Address')}</StrongText>
                            <NormalText className='secondary-color primary-regular' >
                              <u>
                                <a href={`https://maps.google.com/?q=${store.address || emptyString}`}>
                                  <a href={`https://maps.apple.com/maps?q=${store.address || emptyString}`}>
                                    {store.address || emptyString}
                                  </a>
                                </a>
                              </u>
                            </NormalText>
                          </div>
                        ) : null}
                        {store.json_opening_time_info && store.json_opening_time_info.length > 0 ? (
                          <div>
                            <StrongText className="map-text roboto-slab">{__('Opening Hours')}</StrongText>
                            <div className="location-info">
                              {store.json_opening_time_info.map((item, index) => {
                                return (
                                  <div key={index} className="location-info-segment">
                                    <NormalText className="primary-regular thiner-text">{item.day}</NormalText>
                                    <NormalText className="primary-regular location-time thiner-text">
                                      {__(item.time)}
                                    </NormalText>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : null}
                        {store.shop_info_json && store.shop_info_json.length > 0 ? (
                          <div>
                            <StrongText className="strong-text">{__('Info')}</StrongText>
                            <ul>
                              {store.shop_info_json.map((info, i) => {
                                return (
                                  <li key={i}>
                                    <NormalText>
                                      <strong>{info.key}:</strong> {info.value}
                                    </NormalText>
                                    <br />
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        ) : null}
                        {store.telephone ? (
                          <div>
                            <StrongText className="no-margin map-text roboto-slab">
                              {__('Telephone')}
                            </StrongText>
                            <NormalText className="secondary-color primary-regular">
                              <u>
                                <a href={`tel:${store.telephone || emptyString}`} data-telegram="telegram">{store.telephone || emptyString}</a>
                              </u>
                            </NormalText>
                          </div>
                        ) : null}
                        {store.email ? (
                          <div>
                            <StrongText className="map-text roboto-slab">{__('Email')}</StrongText>
                            <NormalText className="secondary-color" color="background">
                              <a href={`mailto:${store.email || emptyString}`}>
                                {store.email || emptyString}
                              </a>
                            </NormalText>
                          </div>
                        ) : null}
                        <div>
                          <NormalText color="background">
                            <a href={`https://horizons-restaurant.paperlessmenu.com/menu`}>
                              {__('View Our Menu')}
                            </a>
                          </NormalText>
                        </div>
                        <div>
                          <NormalText color="background">
                            <a href={`https://go-to-dishcult.app.link/pCGYannj9nb`}>
                              {__('Book a Table')}
                            </a>
                          </NormalText>
                        </div>
                      </IonSlide>
                    );
                  })}
                </IonSlides>
              </IonContent>
              <div className="map-location-nav" onClick={() => this.changeSlideArrow('next')}>
                <IonButton size="small" fill="clear">
                  <IonIcon slot="icon-only" color="gray" icon={chevronForwardOutline} />
                </IonButton>
              </div>
            </div>
          </div>
        </Pullup>
      </Loading>
    );
  }
}

const stateToProps = (state) => {
  const { restaurants } = state.restaurants;
  return {
    restaurants: restaurants || [],
  };
};

export default GoogleApiWrapper({
  apiKey: getConfig().services.google_maps.google_api_key,
})(withRouter(withTranslation(connect(stateToProps)(MapContainer))));
